class UtilityPageTransition {
  constructor(el) {
    this.el = el;
    this.bindUI();
    this.bindEvents();
  }

  bindUI() {
    this.$container = this.el;
  }

  bindEvents() {
    document.addEventListener('click', (e) => this.handleLinkClick(e));
  }

  resetContainerStyle() {
    if (this.$container) this.$container.style.transform = 'none';
  }

  showWithoutAnimation() {
    if (this.$container) {
      gsap.set(this.$container, { opacity: 1, y: 0 });
      this.resetContainerStyle();
    }
  }

  animateIn() {
    gsap.fromTo(this.$container, { 
      opacity: 0,
      y: 16
    }, {
      opacity: 1,
      y: 0,
      duration: 0.6,
      delay: 0.1,
      ease: 'power4.out',
      onComplete: () => this.resetContainerStyle()
    });
  }

  animateOut() {
    return gsap.to(this.$container, {
      opacity: 0,
      y: -16,
      duration: 0.4,
      ease: 'power2.in',
      onComplete: () => this.resetContainerStyle()
    });
  }

  isInternalLink(link) {
    return link.hostname === window.location.hostname && !link.hasAttribute('target') && !link.hasAttribute('download');
  }

  handleLinkClick(e) {
    const link = e.target.closest('a');
    if (!link || !this.isInternalLink(link)) return;
    if (link.hash && link.pathname + link.search === window.location.pathname + window.location.search) return;
    e.preventDefault();
    if (this.$container) {
      this.animateOut().then(() => {
        window.location.href = link.href;
      });
    } else {
      window.location.href = link.href;
    }
  }
}

function initPageTransition() {
  document.querySelectorAll('.js-page-transition').forEach(el => {
    const pageTransition = new UtilityPageTransition(el);
    pageTransition.animateIn();
  });
}

// Gérer le retour arrière du navigateur (afficher sans animation)
window.addEventListener('pageshow', (event) => {
  if (event.persisted) {
    const container = document.querySelector('.js-page-transition');
    if (container) {
      const pageTransition = new UtilityPageTransition(container);
      pageTransition.showWithoutAnimation();
    }
  }
});

window.addEventListener('font-size-updated', initPageTransition);
